import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";

export default function StepsBar() {
    const path = useLocation().pathname;

    let currentStep = 0;

    if (path.match('/cart/?$')) currentStep = 1;
    if (path.match('/cart/checkout/?$')) currentStep = 2;
    if (path.match('/cart/summary/(.*)$')) currentStep = 3;

    return (
        <Row className="justify-content-center m-0 text-center">
            <CartStepBar currentStep={currentStep} />
            <Col sm={1} className="p-0 d-none d-sm-block">
                <div className="mt-4 border-top border-black"></div>
            </Col>
            <CheckoutStepBar currentStep={currentStep} />
            <Col sm={1} className="p-0 d-none d-sm-block">
                <div className="mt-4 border-top border-black"></div>
            </Col>
            <SummaryStepBar currentStep={currentStep} />
        </Row>
    )
}

const CartStepBar = ({ currentStep }: { currentStep: number }) => {
    const className = (currentStep > 1) ? "bi-check-circle" : "bi-1-circle-fill";

    return (
        <SingleStepBar
            circleClass={className}
            text={'cart'} />
    );
}

const CheckoutStepBar = ({ currentStep }: { currentStep: number }) => {
    const className = (currentStep > 2
        ? "bi-check-circle"
        : (currentStep === 2 ? "bi-2-circle-fill" : "bi-2-circle"));

    return (
        <SingleStepBar
            circleClass={className}
            text={'checkout'} />
    );
}

const SummaryStepBar = ({ currentStep }: { currentStep: number }) => {
    const className = (currentStep > 3
        ? "bi-check-circle"
        : (currentStep === 3 ? "bi-3-circle-fill" : "bi-3-circle"));

    return (
        <SingleStepBar
            circleClass={className}
            text={'summary'} />
    );
}

const SingleStepBar = ({ circleClass, text }: any) => {
    const { t } = useTranslation('cart');

    return (
        <Col xs sm className="p-0">
            <i className={circleClass} style={{ fontSize: "2rem" }}></i>
            <div><small>{t('stepBar.' + text)}</small></div>
        </Col>
    );
}